/** Shared snapshot of the vehicles currently shown on the map (updated by Map.vue). */
export const vehiclesFromMapStore: {vehiclesFromMap: Array<any>} = {
    vehiclesFromMap: []
};
